<template>
  <footer class="flex justify-between items-center">
    <app-multi-button1
      v-if="isConversionInProgress"
      btn-type="credit"
      :btn-text="$t('gallery.speedUpAll')"
      :btn-count="speedupCost"
      add-class="converter-speed-up-all-btn"
      :popup-data="{
        title: $t('gallery.speedUp'),
        btnText: $t('gallery.speedUp'),
        btnType: 'confirm',
        btnValue: speedupCost,
        btnId: 'gallery-convert-speed-up-all-id',
        text: $t('gallery.speedUpAllConfirmMessage'),
      }"
      @action="$debounce(() => $emit('speedup-all'))"
    />

    <div v-else class="flex text-texts-standard-default">
      <span class="text-34 ml-5">{{ `${$t('gallery.price')}:` }}</span>

      <div class="convert-price text-36 flexing">
        <span class="mr-2">{{ selectedAmount }}</span>
        <app-main-icon :icon-size="48" :icon-name="`puzzle-${conversionType}`" />
      </div>
    </div>

    <app-button
      v-if="!isConversionInProgress"
      class="convert-btn"
      btn-id="gallery-convert-btn"
      btn-type="secondary"
      :btn-text="$t('gallery.convert')"
      btn-size="md"
      :disabled="!isConversionPossible"
      @click="$emit('start-convert')"
    />
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppSlider from '../GlobalComponents/AppSlider.vue'
import GalleryConverterHeader from './GalleryConverterHeader.vue'

export default defineComponent({
  name: 'GalleryConverterFooter',

  components: { AppSlider, GalleryConverterHeader },

  props: {
    isConversionInProgress: {
      type: Boolean,
      default: false,
    },

    speedupCost: {
      type: Number,
      required: true,
    },

    selectedAmount: {
      type: Number,
      required: true,
    },

    conversionType: {
      type: String,
      required: true,
    },

    isConversionPossible: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['start-convert', 'speedup-all']
})
</script>

<style lang="scss" scoped>
.gallery-converter footer {
  width: 56rem;
  height: 6.125rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  @if $isWsm {
    background: linear-gradient(to right, #0d2038, #215d84, #061123);
  }
  @if $isSsm {
    background: linear-gradient(to right, #1d1f2c, #2e3c63, #1d1f2c);
  }
  .convert-price {
    width: 10rem;
    height: 3.5rem;
    border-style: solid;
    border-width: 0.125rem;
    border-image-slice: 1;
    @if $isWsm {
      background: linear-gradient(to right, transparent, #6c9ec4, transparent);
      border-image-source: linear-gradient(to right, transparent, #fff, transparent);
    }
    @if $isSsm {
      background: linear-gradient(to right, transparent, #373f59, transparent);
      border-image-source: linear-gradient(to right, transparent, #586b9d, transparent);
    }
  }
  .converter-speed-up-all-btn {
    width: 54.25rem;
  }
}
</style>
